
import { Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import EventCodeConfigs, { Banner, CustomBanner } from '@/interfaces/event-code-configs'
import {
  modalOptionsCouponLotus,
  modalOptionsCouponBZB,
  getUrlModalOptionsMyCoupon,
} from '@/model/modal-options.model'
import { MyCoupon } from '@/model/my-coupon.model'
import { useStore } from '@/store'
import ModalIframeOptions from '@/interfaces/modal-iframe-options'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'
import liff from '@line/liff'

export default class DefaultBanner extends Vue {
  store = useStore()
  @Prop({ required: true }) defaultConfig!: EventCodeConfigs | Record<string, unknown>
  textTitleLifestyle = MyCoupon.COUPON_LIFESTYLE_TITLE
  textTitleLotus = MyCoupon.COUPON_LOTUS_TITLE

  // Lite tier = customerType 'online'
  get isLite(): boolean {
    return this.store.state.customer?.customerType === 'online'
  }

  get groupedBanners(): Banner[][] {
    const groupWidget = (this.defaultConfig as any).custom_banners?.find((b: { banner_type: string }) => b.banner_type === 'group-widget')
    return groupWidget ? this.groupBanners(groupWidget.banners) : []
  }

  bannerStyle(banner: CustomBanner, options: { isFull?: boolean; setWidth?: boolean } = {}) {
    const { isFull = false } = options

    return {
      display: 'flex',
      alignItems: 'center',
      minHeight: '72px',
      borderRadius: '8px',
      padding: '6px 8px',
      background: `url(${banner.background_image_url})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      ...(isFull && { width: '100%' }),
      ...banner.style
    }
  }

  bannerWidgetStyle(banner: CustomBanner) {
    return {
      display: 'flex',
      ...banner.style
    }
  }

  bannerRowStyle(banner: CustomBanner) {
    if (!banner.row) {
      return
    }

    return {
      ...banner.row.style
    }
  }

  handleClickBanner(banner: Banner | CustomBanner) {
    // Lite member (online) can open the widget only if the banner config allows it
    const canOpenWidget = !this.isLite || banner?.action?.is_lite_member_open_widget === true

    if (!canOpenWidget) {
      // Lite member -> Upgrade to Loyalty journey (onelink)
      liff.openWindow({
        url: process.env.VUE_APP_ACTIVATE_LOYALTY_URL!
      })
      return
    }

    this.$emit('handleClickBanner', banner)
  }

  errorImage(event: any) {
    event.target.onerror = null
    event.target.src = require('../../assets/img/no-image-placeholder-carausol.png')
  }

  groupBanners(banners: Banner[]): Banner[][] {
    const rows: Banner[][] = []
    let currentRow: Banner[] = []
    let total = 0

    banners.forEach((banner: Banner) => {
      const w = parseFloat(banner?.style?.width) || 0

      if (total + w > 100) {
        rows.push(currentRow)

        //clear current row and total
        currentRow = []
        total = 0
      }
      // add banner to current row and update total
      currentRow.push(banner)
      total += w
    })
    // push the last row if it has banners left
    if (currentRow.length > 0) {
      rows.push(currentRow)
    }

    return rows
  }

  updateGAEvent(txtTab: string) {
    addGAEvent({
      event: 'mylotuss_icon_tab',
      icon_tab: txtTab,
    })
  }

  updateModalIframe(isActive: boolean, modalOptions: ModalIframeOptions) {
    this.store.commit('modalIframe/updateModalIframeActive', isActive)
    this.store.commit('modalIframe/updateModalOptionsIframe', modalOptions)
  }

  openModalCouponLotus() {
    const customerType = this.store.state.customer?.customerType ?? undefined
    modalOptionsCouponLotus.url = getUrlModalOptionsMyCoupon(undefined, 'lotus', 'coupon', undefined, customerType, undefined)
    this.updateModalIframe(true, modalOptionsCouponLotus)
    this.updateGAEvent(MyCoupon.COUPON_LOTUS_TITLE)
  }

  openModalCouponBZB() {
    const customerType = this.store.state.customer?.customerType ?? undefined
    const socialToken = this.store.state.lineInfo?.socialToken ?? undefined
    modalOptionsCouponBZB.url = getUrlModalOptionsMyCoupon(undefined, 'lifestyle', 'offer', undefined, customerType, socialToken)
    this.updateModalIframe(true, modalOptionsCouponBZB)
    this.updateGAEvent(MyCoupon.COUPON_LIFESTYLE_TITLE)
  }
}
